// extracted by mini-css-extract-plugin
export default {"norms__name":"DetailsTable_norms__name__ZcS47"};